module.exports = __webpack_public_path__ + "img/2025-02-13c_4.e68dda4d.png";